// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","root":"_3kne","inner":"_2Bbn","filled":"YoeO"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Text/HeadingBanner/HeadingBanner.scss
// module id = JLk4
// module chunks = 0